import { useCallback, useState } from "react";

import { ConnectorModal } from "../connector-modal";

import {
  ConnectorContext,
  type ConnectorProviderProps,
  type InactiveModalState,
  inactiveModalState,
  type ModalProps,
} from "./ConnectorContextContext";

export const ConnectorProvider = ({ children }: ConnectorProviderProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalProps, setModalProps] = useState<ModalProps | InactiveModalState>(inactiveModalState);

  const openConnectorModal = useCallback(
    (name, connectHandler, title, formFields, link, showRutterDisclaimer, showCodatDisclaimer) => {
      setModalOpen(true);
      setModalProps({
        name,
        connectHandler,
        title,
        formFields,
        link,
        showRutterDisclaimer,
        showCodatDisclaimer,
      });
    },
    []
  );
  const updateConnectorModalFields = useCallback(
    (name, formFields, showRutterDisclaimer, showCodatDisclaimer, link) => {
      if (modalProps.name === name) {
        setModalProps({ ...modalProps, formFields, link });
      }
    },
    [modalProps]
  );
  const closeConnectorModal = useCallback(() => {
    setModalOpen(false);
    setModalProps(inactiveModalState);
  }, []);
  return (
    <>
      <ConnectorModal isOpen={modalOpen} close={closeConnectorModal} {...modalProps} />
      <ConnectorContext.Provider
        value={{
          updateConnectorModalFields,
          openConnectorModal,
          closeConnectorModal,
        }}
      >
        {children}
      </ConnectorContext.Provider>
    </>
  );
};
